export const LogoSmall = ({ color = 'white' }) => (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5352 3.05033C21.7238 3.51439 21.8224 4.01008 21.8258 4.51098C21.8466 5.75296 21.4841 6.90406 20.9606 8.01351C20.32 9.35576 19.4579 10.5805 18.4104 11.6363C18.3046 11.7627 18.1762 11.8684 18.0317 11.9477C17.9037 11.9925 17.7633 11.985 17.6408 11.9269C17.5867 11.8982 17.5445 11.8513 17.5218 11.7944C17.4991 11.7375 17.4973 11.6744 17.5168 11.6164C17.5234 11.5856 17.5346 11.5559 17.5499 11.5284C17.6253 11.3901 17.7134 11.2593 17.8131 11.1374C18.772 9.95032 19.6628 8.7197 20.2743 7.31206C20.5819 6.60682 20.8177 5.88454 20.8868 5.12818V5.11872C20.8918 5.06507 20.8956 5.01112 20.8981 4.95684C20.8981 4.9133 20.8981 4.86975 20.9038 4.82715C20.9038 4.67191 20.9038 4.51571 20.8962 4.35384C20.8749 3.89264 20.7406 3.44373 20.5053 3.04654C20.0812 2.35266 19.3438 1.95129 18.4113 1.83675C18.0215 1.79054 17.6281 1.78198 17.2366 1.81119C17.3227 1.81781 17.4098 1.82633 17.4969 1.83675C18.4293 1.95129 19.1667 2.35266 19.5908 3.04654H13.2938C12.2273 3.58711 11.2216 4.24022 10.294 4.99471C8.67522 6.29822 7.02998 7.57238 5.46141 8.93364C4.23079 10.0024 3.12228 11.2056 2.3309 12.6369V15.7607L2.38959 15.8071C2.93106 16.218 3.56247 16.4082 4.21564 16.5474C5.01555 16.7178 5.82492 16.75 6.64091 16.7594C7.1076 16.7651 7.57334 16.803 8.04003 16.8143C9.21385 16.8427 10.3896 16.8361 11.5624 16.8958C13.6763 17.0027 15.7532 17.3397 17.7468 18.0847C18.9348 18.5287 20.032 19.1317 20.9511 20.0234C21.6342 20.6629 22.1208 21.4838 22.354 22.39C22.3872 22.5235 22.4156 22.6598 22.4383 22.7989C22.4449 22.8434 22.4544 22.887 22.4648 22.9315C22.4766 22.9564 22.4902 22.9805 22.5055 23.0034C22.7895 22.7791 23.0593 22.5793 23.3101 22.354C25.1636 20.6946 27.2216 19.3182 29.326 18.0062C29.4566 17.9238 29.5854 17.8377 29.715 17.7543C29.7558 17.7278 29.7965 17.7004 29.8381 17.6748C29.9194 17.6208 30.0072 17.5772 30.0994 17.5451C30.2006 17.5113 30.3105 17.515 30.4092 17.5555C30.5079 17.596 30.5888 17.6706 30.6371 17.7657C30.6876 17.8601 30.7011 17.97 30.6748 18.0739C30.6485 18.1777 30.5844 18.268 30.4951 18.3271C30.2357 18.5088 29.9678 18.6764 29.6999 18.8449C27.712 20.0973 25.7572 21.4008 23.9927 22.9656C23.5477 23.3603 23.0631 23.7077 22.604 24.0864C22.5256 24.1513 22.4713 24.2406 22.4496 24.3401C22.2461 25.6511 21.6441 26.7805 20.9417 27.8852C20.2668 28.9482 19.4752 29.9325 18.5817 30.8198C17.9124 31.4824 17.2186 32.1252 16.3941 32.5928C16.0491 32.7901 15.6778 32.9371 15.2912 33.0292C15.0863 33.081 14.8692 33.0497 14.6873 32.9421C14.5705 32.8666 14.4766 32.7606 14.4155 32.6357C14.3545 32.5108 14.3287 32.3716 14.3408 32.2331C14.3632 31.889 14.4479 31.5519 14.5907 31.2382C15.0091 30.3019 15.632 29.4926 16.2899 28.7182C17.2905 27.5473 18.4284 26.5145 19.5785 25.4997C20.2326 24.9213 20.8839 24.3401 21.5267 23.7484C21.5943 23.6643 21.628 23.5579 21.6213 23.4502C21.6195 23.3021 21.6094 23.1542 21.5911 23.0072C21.5448 22.6253 21.4405 22.2528 21.2815 21.9025C21.0033 21.312 20.6033 20.7871 20.1077 20.3623C19.1118 19.4791 17.9181 18.9651 16.6676 18.5722C15.0591 18.0845 13.3966 17.7964 11.7177 17.7146C10.523 17.6445 9.32556 17.6199 8.12901 17.5887C7.61783 17.5764 7.10571 17.5821 6.59453 17.5811H6.44875C6.12026 17.5811 5.79178 17.5745 5.46425 17.5584C4.58202 17.5244 3.71129 17.3463 2.88657 17.0311C2.69464 16.9559 2.50776 16.8683 2.32711 16.7689C1.98352 16.584 1.68033 16.3323 1.43539 16.0286C1.28893 15.8452 1.16998 15.6415 1.08229 15.4237C0.856048 14.8605 0.871194 14.2565 1.03307 13.6251C1.10737 13.3449 1.20391 13.0711 1.32179 12.8063C1.5951 12.2142 1.93356 11.6545 2.3309 11.1374L2.37066 11.0834C3.39231 9.73745 4.56887 8.51641 5.87603 7.44554C7.48531 6.10321 9.09931 4.77036 10.7786 3.5227C10.9983 3.35987 11.2226 3.20273 11.4489 3.04938C12.926 2.05329 14.5879 1.36348 16.3363 1.02075C16.6491 0.959978 16.9652 0.917621 17.2829 0.8939C16.6581 0.853067 16.0307 0.895727 15.4171 1.02075C13.669 1.36331 12.0074 2.05313 10.5306 3.04938H2.3309V10.0014C2.02703 10.3507 1.73358 10.7105 1.45527 11.0844C0.876874 11.8616 0.368533 12.6795 0.122409 13.6299C-0.10005 14.4875 -0.0489311 15.3045 0.523781 16.0296C0.902433 16.5114 1.41456 16.8115 1.97591 17.0321C2.0933 17.0775 2.21257 17.1201 2.3309 17.1599V34.8789H34.1604V3.05033H21.5352ZM30.5017 24.2747C30.1865 24.7348 29.5939 25.0027 28.9237 24.9876C28.9189 25.0065 28.9132 25.0254 28.9076 25.0444C28.7703 25.0074 28.6236 24.9828 28.4863 24.9497C28.3762 24.925 28.2694 24.8872 28.1682 24.837C27.7025 24.5947 27.5596 24.0712 27.7849 23.596C27.9856 23.171 28.4475 22.8728 28.9435 22.7545C29.4169 22.6428 29.9318 22.6929 30.2953 22.9561C30.727 23.2666 30.8131 23.8223 30.5017 24.2747Z"
      fill={color}
    />
    <path
      d="M21.1726 25.229C20.7305 25.6389 20.2846 26.0459 19.8473 26.4596C19.7009 26.5978 19.5548 26.737 19.409 26.8771C18.6839 27.5776 17.9531 28.2734 17.263 29.007C16.5729 29.7406 15.9377 30.5519 15.4843 31.4683L15.4795 31.4768C15.4268 31.5884 15.3913 31.7075 15.3745 31.8299C15.3546 31.9624 15.4313 32.0419 15.5638 31.9813C15.7721 31.8993 15.9703 31.7935 16.1545 31.6661C17.0298 30.977 17.854 30.2253 18.6205 29.4169C19.708 28.2874 20.5857 26.9731 21.2123 25.5357C21.2672 25.4117 21.307 25.282 21.3534 25.1571C21.3537 25.1542 21.3537 25.1514 21.3534 25.1485L21.3098 25.1249C21.2623 25.1572 21.2165 25.192 21.1726 25.229Z"
      fill={color}
    />
  </svg>
);

export const LogoSmallAnimated = ({ color = 'white' }) => {
  // Estilos CSS para la animación
  const dashValue = 300;

  // Estilos CSS para la animación
  const style = {
    path: {
      fill: 'none',
      stroke: color,
      strokeWidth: '2',
      strokeDasharray: dashValue,
      strokeDashoffset: -dashValue,
      animation: 'draw 3s infinite'
    }
  };

  // Las animaciones @keyframes de CSS inyectadas directamente en el componente
  const keyframes = `
  @keyframes draw {
    0% {
      stroke-dashoffset: -${dashValue};
    }
    50% {
      stroke-dashoffset: 0;
    }
    100% {
      stroke-dashoffset: -${dashValue};
    }
  }
`;

  return (
    <>
      <style>{keyframes}</style>
      <svg
        width="100"
        height="100"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >

        <path
            d="M21.5352 3.05033C21.7238 3.51439 21.8224 4.01008 21.8258 4.51098C21.8466 5.75296 21.4841 6.90406 20.9606 8.01351C20.32 9.35576 19.4579 10.5805 18.4104 11.6363C18.3046 11.7627 18.1762 11.8684 18.0317 11.9477C17.9037 11.9925 17.7633 11.985 17.6408 11.9269C17.5867 11.8982 17.5445 11.8513 17.5218 11.7944C17.4991 11.7375 17.4973 11.6744 17.5168 11.6164C17.5234 11.5856 17.5346 11.5559 17.5499 11.5284C17.6253 11.3901 17.7134 11.2593 17.8131 11.1374C18.772 9.95032 19.6628 8.7197 20.2743 7.31206C20.5819 6.60682 20.8177 5.88454 20.8868 5.12818V5.11872C20.8918 5.06507 20.8956 5.01112 20.8981 4.95684C20.8981 4.9133 20.8981 4.86975 20.9038 4.82715C20.9038 4.67191 20.9038 4.51571 20.8962 4.35384C20.8749 3.89264 20.7406 3.44373 20.5053 3.04654C20.0812 2.35266 19.3438 1.95129 18.4113 1.83675C18.0215 1.79054 17.6281 1.78198 17.2366 1.81119C17.3227 1.81781 17.4098 1.82633 17.4969 1.83675C18.4293 1.95129 19.1667 2.35266 19.5908 3.04654H13.2938C12.2273 3.58711 11.2216 4.24022 10.294 4.99471C8.67522 6.29822 7.02998 7.57238 5.46141 8.93364C4.23079 10.0024 3.12228 11.2056 2.3309 12.6369V15.7607L2.38959 15.8071C2.93106 16.218 3.56247 16.4082 4.21564 16.5474C5.01555 16.7178 5.82492 16.75 6.64091 16.7594C7.1076 16.7651 7.57334 16.803 8.04003 16.8143C9.21385 16.8427 10.3896 16.8361 11.5624 16.8958C13.6763 17.0027 15.7532 17.3397 17.7468 18.0847C18.9348 18.5287 20.032 19.1317 20.9511 20.0234C21.6342 20.6629 22.1208 21.4838 22.354 22.39C22.3872 22.5235 22.4156 22.6598 22.4383 22.7989C22.4449 22.8434 22.4544 22.887 22.4648 22.9315C22.4766 22.9564 22.4902 22.9805 22.5055 23.0034C22.7895 22.7791 23.0593 22.5793 23.3101 22.354C25.1636 20.6946 27.2216 19.3182 29.326 18.0062C29.4566 17.9238 29.5854 17.8377 29.715 17.7543C29.7558 17.7278 29.7965 17.7004 29.8381 17.6748C29.9194 17.6208 30.0072 17.5772 30.0994 17.5451C30.2006 17.5113 30.3105 17.515 30.4092 17.5555C30.5079 17.596 30.5888 17.6706 30.6371 17.7657C30.6876 17.8601 30.7011 17.97 30.6748 18.0739C30.6485 18.1777 30.5844 18.268 30.4951 18.3271C30.2357 18.5088 29.9678 18.6764 29.6999 18.8449C27.712 20.0973 25.7572 21.4008 23.9927 22.9656C23.5477 23.3603 23.0631 23.7077 22.604 24.0864C22.5256 24.1513 22.4713 24.2406 22.4496 24.3401C22.2461 25.6511 21.6441 26.7805 20.9417 27.8852C20.2668 28.9482 19.4752 29.9325 18.5817 30.8198C17.9124 31.4824 17.2186 32.1252 16.3941 32.5928C16.0491 32.7901 15.6778 32.9371 15.2912 33.0292C15.0863 33.081 14.8692 33.0497 14.6873 32.9421C14.5705 32.8666 14.4766 32.7606 14.4155 32.6357C14.3545 32.5108 14.3287 32.3716 14.3408 32.2331C14.3632 31.889 14.4479 31.5519 14.5907 31.2382C15.0091 30.3019 15.632 29.4926 16.2899 28.7182C17.2905 27.5473 18.4284 26.5145 19.5785 25.4997C20.2326 24.9213 20.8839 24.3401 21.5267 23.7484C21.5943 23.6643 21.628 23.5579 21.6213 23.4502C21.6195 23.3021 21.6094 23.1542 21.5911 23.0072C21.5448 22.6253 21.4405 22.2528 21.2815 21.9025C21.0033 21.312 20.6033 20.7871 20.1077 20.3623C19.1118 19.4791 17.9181 18.9651 16.6676 18.5722C15.0591 18.0845 13.3966 17.7964 11.7177 17.7146C10.523 17.6445 9.32556 17.6199 8.12901 17.5887C7.61783 17.5764 7.10571 17.5821 6.59453 17.5811H6.44875C6.12026 17.5811 5.79178 17.5745 5.46425 17.5584C4.58202 17.5244 3.71129 17.3463 2.88657 17.0311C2.69464 16.9559 2.50776 16.8683 2.32711 16.7689C1.98352 16.584 1.68033 16.3323 1.43539 16.0286C1.28893 15.8452 1.16998 15.6415 1.08229 15.4237C0.856048 14.8605 0.871194 14.2565 1.03307 13.6251C1.10737 13.3449 1.20391 13.0711 1.32179 12.8063C1.5951 12.2142 1.93356 11.6545 2.3309 11.1374L2.37066 11.0834C3.39231 9.73745 4.56887 8.51641 5.87603 7.44554C7.48531 6.10321 9.09931 4.77036 10.7786 3.5227C10.9983 3.35987 11.2226 3.20273 11.4489 3.04938C12.926 2.05329 14.5879 1.36348 16.3363 1.02075C16.6491 0.959978 16.9652 0.917621 17.2829 0.8939C16.6581 0.853067 16.0307 0.895727 15.4171 1.02075C13.669 1.36331 12.0074 2.05313 10.5306 3.04938H2.3309V10.0014C2.02703 10.3507 1.73358 10.7105 1.45527 11.0844C0.876874 11.8616 0.368533 12.6795 0.122409 13.6299C-0.10005 14.4875 -0.0489311 15.3045 0.523781 16.0296C0.902433 16.5114 1.41456 16.8115 1.97591 17.0321C2.0933 17.0775 2.21257 17.1201 2.3309 17.1599V34.8789H34.1604V3.05033H21.5352ZM30.5017 24.2747C30.1865 24.7348 29.5939 25.0027 28.9237 24.9876C28.9189 25.0065 28.9132 25.0254 28.9076 25.0444C28.7703 25.0074 28.6236 24.9828 28.4863 24.9497C28.3762 24.925 28.2694 24.8872 28.1682 24.837C27.7025 24.5947 27.5596 24.0712 27.7849 23.596C27.9856 23.171 28.4475 22.8728 28.9435 22.7545C29.4169 22.6428 29.9318 22.6929 30.2953 22.9561C30.727 23.2666 30.8131 23.8223 30.5017 24.2747Z"
          style={style.path}
        />
        <path
            d="M21.1726 25.229C20.7305 25.6389 20.2846 26.0459 19.8473 26.4596C19.7009 26.5978 19.5548 26.737 19.409 26.8771C18.6839 27.5776 17.9531 28.2734 17.263 29.007C16.5729 29.7406 15.9377 30.5519 15.4843 31.4683L15.4795 31.4768C15.4268 31.5884 15.3913 31.7075 15.3745 31.8299C15.3546 31.9624 15.4313 32.0419 15.5638 31.9813C15.7721 31.8993 15.9703 31.7935 16.1545 31.6661C17.0298 30.977 17.854 30.2253 18.6205 29.4169C19.708 28.2874 20.5857 26.9731 21.2123 25.5357C21.2672 25.4117 21.307 25.282 21.3534 25.1571C21.3537 25.1542 21.3537 25.1514 21.3534 25.1485L21.3098 25.1249C21.2623 25.1572 21.2165 25.192 21.1726 25.229Z"
          style={style.path}
          />
      </svg>
    </>
  );
};

export const AddUser = ({ size = '25px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.05884 7.62891C8.9729 7.62891 10.5588 6.07031 10.5588 4.12891C10.5588 2.21484 8.9729 0.628906 7.05884 0.628906C5.11743 0.628906 3.55884 2.21484 3.55884 4.12891C3.55884 6.07031 5.11743 7.62891 7.05884 7.62891ZM7.05884 1.94141C8.26196 1.94141 9.24634 2.92578 9.24634 4.12891C9.24634 5.35938 8.26196 6.31641 7.05884 6.31641C5.82837 6.31641 4.87134 5.35938 4.87134 4.12891C4.87134 2.92578 5.82837 1.94141 7.05884 1.94141ZM8.42603 8.94141H5.66431C3.03931 8.94141 0.933838 11.0742 0.933838 13.6992C0.933838 14.2188 1.34399 14.6289 1.86353 14.6289H12.2268C12.7463 14.6289 13.1838 14.2188 13.1838 13.6992C13.1838 11.0742 11.051 8.94141 8.42603 8.94141ZM2.24634 13.3164C2.43774 11.6211 3.88696 10.2539 5.66431 10.2539H8.42603C10.2034 10.2539 11.6252 11.6211 11.844 13.3164H2.24634ZM17.7776 6.09766H16.4651V4.78516C16.4651 4.42969 16.1643 4.12891 15.8088 4.12891C15.426 4.12891 15.1526 4.42969 15.1526 4.78516V6.09766H13.8401C13.4573 6.09766 13.1838 6.39844 13.1838 6.75391C13.1838 7.13672 13.4573 7.41016 13.8401 7.41016H15.1526V8.72266C15.1526 9.10547 15.426 9.37891 15.8088 9.37891C16.1643 9.37891 16.4651 9.10547 16.4651 8.72266V7.41016H17.7776C18.1331 7.41016 18.4338 7.13672 18.4338 6.75391C18.4338 6.39844 18.1331 6.09766 17.7776 6.09766Z"
      fill="currentColor"
    />
  </svg>
);

export const SignIcon = ({ size = '20px', color = '#000000' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.9375 5.15625C6.9375 5.64844 6.55078 6 6.09375 6C5.60156 6 5.25 5.64844 5.25 5.15625V3.75C5.25 1.88672 6.72656 0.375 8.625 0.375C10.4883 0.375 12 1.88672 12 3.75V4.03125C12 4.83984 11.9297 5.61328 11.8242 6.38672L16.5 4.94531C16.8164 4.83984 17.168 4.91016 17.3789 5.15625C17.5898 5.36719 17.6602 5.71875 17.5547 6.03516L16.5703 8.8125H20.1562C20.6133 8.8125 21 9.19922 21 9.65625C21 10.1484 20.6133 10.5 20.1562 10.5H15.375C15.0938 10.5 14.8125 10.3945 14.6719 10.1484C14.4961 9.9375 14.4609 9.65625 14.5664 9.375L15.4102 7.05469L11.5078 8.25L11.4727 8.42578C11.0156 10.3945 10.2773 12.293 9.22266 14.0156L8.66016 14.9297C8.23828 15.7031 7.42969 16.125 6.55078 16.125C5.21484 16.125 4.125 15.0352 4.125 13.6641V11.0625C4.125 9.69141 5.00391 8.49609 6.26953 8.10938L10.0664 6.91406C10.207 5.96484 10.3125 5.01562 10.3125 4.03125V3.75C10.3125 2.83594 9.53906 2.0625 8.625 2.0625C7.67578 2.0625 6.9375 2.83594 6.9375 3.75V5.15625ZM5.8125 11.0625V13.6641C5.8125 14.1211 6.12891 14.4375 6.55078 14.4375C6.83203 14.4375 7.07812 14.2969 7.21875 14.0859L7.78125 13.1367C8.58984 11.8008 9.22266 10.3594 9.64453 8.8125L6.79688 9.69141C6.19922 9.90234 5.8125 10.4297 5.8125 11.0625ZM3 13.6641C3 13.7344 3 13.8047 3 13.875H1.59375C1.10156 13.875 0.75 13.5234 0.75 13.0312C0.75 12.5742 1.10156 12.1875 1.59375 12.1875H3V13.6641ZM10.5938 13.875C10.9102 13.3477 11.1914 12.7852 11.4375 12.1875H22.4062C22.8633 12.1875 23.25 12.5742 23.25 13.0312C23.25 13.5234 22.8633 13.875 22.4062 13.875H10.5938Z"
      fill={color}
    />
  </svg>
);

export const EyeIcon = ({ size = '20px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
      stroke="#96F50F"
      strokeWidth="2"
    />
    <circle cx="12" cy="12" r="3" fill="#96F50F" />
  </svg>
);

export const FingerIcon = ({ size = '25px', color = '#96F50F' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 8.89844C9.50781 8.89844 9.19141 9.28516 9.19141 9.74219C9.22656 12.2734 8.875 14.6992 8.20703 17.1602C8.06641 17.5469 8.24219 18.25 8.98047 18.25C9.36719 18.25 9.68359 18.0391 9.78906 17.6523C10.2812 15.9648 10.8438 13.2578 10.8438 9.74219C10.8438 9.28516 10.457 8.89844 10 8.89844ZM9.96484 6.05078C7.78516 6.05078 6.30859 7.70312 6.34375 9.60156C6.34375 11.2891 6.20312 12.9766 5.85156 14.5938C5.74609 15.0156 6.0625 15.5078 6.51953 15.6133C6.94141 15.6836 7.39844 15.4023 7.50391 14.9453C7.89062 13.1875 8.03125 11.3945 8.03125 9.60156C7.99609 8.65234 8.69922 7.73828 9.92969 7.73828C11.0195 7.73828 11.9336 8.61719 11.9688 9.67188C11.9688 11.3242 11.8633 13.082 11.582 14.7344C11.5117 15.1562 11.8281 15.6133 12.2852 15.6836C12.9883 15.8242 13.2344 15.1562 13.2344 15.0156C13.5508 13.2578 13.6562 11.4297 13.6562 9.67188C13.6211 7.70312 11.9688 6.08594 9.96484 6.05078ZM6.0625 5.34766C5.71094 5.06641 5.18359 5.10156 4.86719 5.45312C3.98828 6.57812 3.49609 7.98438 3.53125 9.39062C3.53125 10.7266 3.42578 12.0625 3.21484 13.3281C3.10938 13.7852 3.42578 14.2422 3.88281 14.3125C4.58594 14.4531 4.83203 13.7852 4.83203 13.6445C5.07812 12.2383 5.18359 10.7969 5.18359 9.39062C5.18359 8.33594 5.53516 7.35156 6.16797 6.54297C6.48438 6.15625 6.41406 5.62891 6.0625 5.34766ZM9.89453 3.16797C9.36719 3.13281 8.83984 3.20312 8.3125 3.34375C7.85547 3.41406 7.57422 3.87109 7.67969 4.36328C7.78516 4.78516 8.20703 5.06641 8.66406 4.96094C9.08594 4.89062 9.47266 4.82031 9.89453 4.85547C12.5312 4.89062 14.7461 7 14.7812 9.56641C14.7812 10.9023 14.7109 12.2031 14.5703 13.5742C14.5352 14.0312 14.8516 14.418 15.3086 14.4883C15.9062 14.5234 16.2227 14.0664 16.2578 13.75C16.3984 12.3438 16.4688 10.9375 16.4688 9.53125C16.3984 6.08594 13.4805 3.20312 9.89453 3.16797ZM18.7891 7.42188C18.6836 7 18.2266 6.68359 17.7695 6.78906C17.3477 6.89453 17.0312 7.31641 17.1367 7.77344C17.2773 8.54688 17.3125 9.10938 17.2773 9.95312C17.2773 10.4102 17.6641 10.7969 18.1211 10.7969C18.5781 10.7969 18.9648 10.4453 18.9648 9.95312C19 9.17969 19 8.40625 18.7891 7.42188ZM17.3477 4.22266C15.625 1.79688 12.8125 0.320312 9.82422 0.25C7.39844 0.25 5.11328 1.12891 3.42578 2.81641C1.80859 4.46875 0.929688 6.61328 0.964844 8.93359V9.70703C0.964844 10.1641 1.35156 10.5508 1.80859 10.5508C1.80859 10.5508 1.80859 10.5508 1.84375 10.5508C2.26562 10.5508 2.65234 10.1992 2.65234 9.74219V8.89844C2.65234 7.07031 3.35547 5.3125 4.65625 4.01172C6.02734 2.67578 7.85547 1.9375 9.85938 1.97266C12.2852 1.97266 14.5703 3.20312 15.9766 5.20703C16.2578 5.59375 16.7852 5.66406 17.1719 5.41797C17.5234 5.13672 17.6289 4.60938 17.3477 4.22266Z"
      fill={color}
    />
  </svg>
);

export const SingleSignature = ({ size = '25px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3281 1.16406C19.3477 0.179688 20.9297 0.144531 21.9492 1.16406L22.3711 1.58594C23.3555 2.57031 23.3555 4.15234 22.3711 5.13672L16.1484 11.3594C15.7969 11.7109 15.375 11.957 14.8828 12.0625L11.8594 12.6602C11.5781 12.7305 11.2969 12.6602 11.1211 12.4492C10.9102 12.2383 10.8047 11.957 10.875 11.6758L11.5078 8.65234C11.6133 8.19531 11.8242 7.73828 12.1758 7.42188L18.3281 1.16406ZM20.7539 2.35938C20.4023 2.00781 19.875 2.00781 19.5586 2.35938L18.8203 3.09766L20.4375 4.71484L21.1758 3.94141C21.4922 3.625 21.4922 3.09766 21.1758 2.78125L20.7539 2.35938ZM13.1602 9.00391L12.8086 10.7617L14.5312 10.4102C14.707 10.375 14.8477 10.2695 14.9531 10.1641L19.2422 5.875L17.625 4.29297L13.3711 8.58203C13.2656 8.72266 13.1953 8.86328 13.1602 9.00391ZM10.0312 4.75C10.4883 4.75 10.875 5.13672 10.875 5.59375C10.875 6.08594 10.4883 6.4375 10.0312 6.4375H3.28125C2.78906 6.4375 2.4375 6.82422 2.4375 7.28125V15.7188C2.4375 16.2109 2.78906 16.5625 3.28125 16.5625H18.4688C18.9258 16.5625 19.3125 16.2109 19.3125 15.7188V11.2188C19.3125 10.7617 19.6641 10.375 20.1562 10.375C20.6133 10.375 21 10.7617 21 11.2188V15.7188C21 17.125 19.8398 18.25 18.4688 18.25H3.28125C1.875 18.25 0.75 17.125 0.75 15.7188V7.28125C0.75 5.91016 1.875 4.75 3.28125 4.75H10.0312ZM4.125 11.5C4.125 10.9023 4.61719 10.375 5.25 10.375C5.84766 10.375 6.375 10.9023 6.375 11.5C6.375 12.1328 5.84766 12.625 5.25 12.625C4.61719 12.625 4.125 12.1328 4.125 11.5ZM9.75 11.5C9.75 12.1328 9.22266 12.625 8.625 12.625C7.99219 12.625 7.5 12.1328 7.5 11.5C7.5 10.9023 7.99219 10.375 8.625 10.375C9.22266 10.375 9.75 10.9023 9.75 11.5Z"
      fill="#96F50F"
    />
  </svg>
);

export const BlockIcon = ({ size = '25px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.125 3.51953V7.5625L19.3242 8.79297C20.0977 9.07422 20.625 9.8125 20.625 10.6211V14.8047C20.625 15.6133 20.1328 16.3164 19.4297 16.6328L16.0547 18.1094C15.5625 18.3203 15 18.3203 14.5078 18.1094L10.5 16.457L6.45703 18.1094C5.96484 18.3203 5.40234 18.3203 4.91016 18.1094L1.53516 16.6328C0.832031 16.3164 0.375 15.6133 0.375 14.8047V10.6211C0.375 9.8125 0.867188 9.07422 1.64062 8.79297L4.875 7.5625V3.51953C4.875 2.71094 5.36719 1.97266 6.17578 1.69141L9.83203 0.390625C10.2539 0.214844 10.7109 0.214844 11.1328 0.390625L14.7891 1.69141C15.5977 1.97266 16.125 2.71094 16.125 3.51953ZM10.5703 1.97266C10.5 1.9375 10.4648 1.9375 10.3945 1.97266L7.54688 2.99219L10.5 4.11719L13.418 2.99219L10.5703 1.97266ZM9.65625 8.65234V5.59375L6.5625 4.39844V7.5625L9.65625 8.65234ZM11.3438 8.65234L14.4375 7.5625V4.39844L11.3438 5.59375V8.65234ZM6.5625 12.6953V16.2812L9.65625 14.9805V11.5352L6.5625 12.6953ZM2.20312 15.0859L4.875 16.2461V12.6953L2.0625 11.6406V14.8047C2.0625 14.9453 2.09766 15.0156 2.20312 15.0859ZM14.4375 12.6953L11.3438 11.5352V14.9805L14.4375 16.2812V12.6953ZM16.125 16.2461L18.7617 15.0859C18.8672 15.0156 18.9375 14.9453 18.9375 14.8047V11.6406L16.125 12.6953V16.2461ZM5.82422 9.07422C5.75391 9.03906 5.68359 9.07422 5.61328 9.07422L2.83594 10.1289L5.71875 11.2188L8.63672 10.0938L5.82422 9.07422ZM12.3281 10.0938L15.2812 11.2188L18.1289 10.1289L15.3516 9.07422C15.2812 9.07422 15.2109 9.03906 15.1406 9.07422L12.3281 10.0938Z"
      fill="#96F50F"
    />
  </svg>
);

export const DownloadIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
  >
    <g stroke="#96F50F" strokeWidth={2}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 7v7m0 0 3-3m-3 3-3-3"
      />
      <path strokeLinecap="round" d="M16 17H8" />
      <path d="M2 12c0-4.714 0-7.071 1.464-8.536C4.93 2 7.286 2 12 2c4.714 0 7.071 0 8.535 1.464C22 4.93 22 7.286 22 12c0 4.714 0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12Z" />
    </g>
  </svg>
);

export const SinglyIcon = ({ size = '25px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.25 2.625H10.168L8.44531 1.04297C8.02344 0.621094 7.46094 0.375 6.86328 0.375H2.75C1.48438 0.375 0.5 1.39453 0.5 2.625V13.875C0.5 15.1406 1.48438 16.125 2.75 16.125H16.25C17.4805 16.125 18.5 15.1406 18.5 13.875V4.875C18.5 3.64453 17.4805 2.625 16.25 2.625ZM2.75 2.0625H6.86328C7.00391 2.0625 7.14453 2.13281 7.25 2.23828L9.5 4.3125H16.25C16.5312 4.3125 16.8125 4.59375 16.8125 4.875V6H2.1875V2.625C2.1875 2.34375 2.43359 2.0625 2.75 2.0625ZM16.25 14.4375H2.75C2.43359 14.4375 2.1875 14.1914 2.1875 13.875V7.6875H16.8125V13.875C16.8125 14.1914 16.5312 14.4375 16.25 14.4375Z"
      fill="#96F50F"
    />
  </svg>
);

export const DriveIcon = ({ size = '25px', color = '#96F50F' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.918 10.3242L6.15234 0.375H11.8125L17.5781 10.3242H11.918ZM7.06641 11.168L4.21875 16.125H15.1523L18 11.168H7.06641ZM5.41406 1.64062L0 11.168L2.8125 16.125L8.33203 6.59766L5.41406 1.64062Z"
      fill={color}
    />
  </svg>
);

export const LeftIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 32 32"
  >
    <path
      fill="white"
      d="M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16Zm0-30C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2Zm7 15H11.414l2.293 2.293a.999.999 0 1 1-1.414 1.414l-4-4a.999.999 0 0 1-.216-1.089.999.999 0 0 1 .216-.325l4-4a.999.999 0 1 1 1.414 1.414L11.414 15H23a1 1 0 0 1 0 2Z"
    />
  </svg>
);

export const RightIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 32 32"
  >
    <path
      fill="white"
      d="M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16Zm0-30C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2Zm7.923 14.382a1 1 0 0 1-.217.326l-3.999 3.999a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L20.586 17H9a1 1 0 0 1 0-2h11.586l-2.293-2.293a.999.999 0 1 1 1.414-1.414l3.999 3.999a1 1 0 0 1 .217 1.09Z"
    />
  </svg>
);

export const ZoomInIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m20 20-5.05-5.05m0 0a7 7 0 1 0-9.9-9.9 7 7 0 0 0 9.9 9.9ZM7 10h6m-3-3v6"
    />
  </svg>
);

export const FullScreenIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4 8V4h4M4 4l5 5M20 16v4h-4M20 20l-5-5M4 16v4h4M4 20l5-5M20 8V4h-4M20 4l-5 5"
    />
  </svg>
);


export const ZoomOutIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m20 20-5.05-5.05m0 0a7 7 0 1 0-9.9-9.9 7 7 0 0 0 9.9 9.9ZM7 10h6"
    />
  </svg>
);

export const DropIcon = ({ size = '25px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.1875 9.5C0.1875 7.47656 2.97656 3.21094 4.28906 1.29688C4.64453 0.804688 5.32812 0.804688 5.68359 1.29688C6.99609 3.21094 9.8125 7.47656 9.8125 9.5C9.8125 12.1797 7.65234 14.3125 5 14.3125C2.32031 14.3125 0.1875 12.1797 0.1875 9.5ZM2.8125 9.5C2.8125 9.28125 2.59375 9.0625 2.375 9.0625C2.12891 9.0625 1.9375 9.28125 1.9375 9.5C1.9375 11.1953 3.30469 12.5625 5 12.5625C5.21875 12.5625 5.4375 12.3711 5.4375 12.125C5.4375 11.9062 5.21875 11.6875 5 11.6875C3.76953 11.6875 2.8125 10.7305 2.8125 9.5Z"
      fill="white"
    />
  </svg>
);

export const RotateLeftIcon = ({ size = '25px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.820312 1.11719C1.06641 1.03516 1.36719 1.08984 1.53125 1.28125L2.67969 2.40234C3.80078 1.28125 5.33203 0.625 6.97266 0.625C10.3633 0.652344 13.125 3.38672 13.125 6.75C13.125 10.1406 10.3633 12.875 7 12.875C5.55078 12.875 4.15625 12.3828 3.0625 11.4805C2.78906 11.2344 2.76172 10.8242 2.98047 10.5508C3.22656 10.2773 3.63672 10.2227 3.91016 10.4688C4.75781 11.1797 5.85156 11.5625 7 11.5625C9.65234 11.5625 11.8125 9.42969 11.8125 6.75C11.8125 4.09766 9.65234 1.9375 7 1.9375C5.6875 1.9375 4.51172 2.48438 3.60938 3.33203L5.03125 4.78125C5.22266 4.94531 5.27734 5.24609 5.19531 5.49219C5.08594 5.73828 4.83984 5.875 4.59375 5.875H1.09375C0.710938 5.875 0.4375 5.60156 0.4375 5.21875V1.71875C0.4375 1.47266 0.574219 1.22656 0.820312 1.11719Z"
      fill="white"
    />
  </svg>
);

export const RotateRightIcon = ({ size = '25px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5625 1.71875V5.21875C13.5625 5.60156 13.2617 5.875 12.9062 5.875H9.40625C9.02344 5.875 8.75 5.60156 8.75 5.24609C8.75 5.05469 8.80469 4.89062 8.94141 4.78125L10.3633 3.33203C9.46094 2.48438 8.28516 1.9375 7 1.9375C4.32031 1.9375 2.1875 4.09766 2.1875 6.75C2.1875 9.42969 4.32031 11.5625 7 11.5625C9.21484 11.5625 9.92578 10.3047 10.4727 10.3047C10.7461 10.3047 11.1289 10.5234 11.1289 10.9609C11.1289 11.6445 9.07812 12.875 6.97266 12.875C3.58203 12.875 0.847656 10.1406 0.847656 6.77734C0.847656 3.38672 3.58203 0.652344 6.97266 0.652344C8.61328 0.652344 10.1445 1.33594 11.2656 2.42969L12.3867 1.30859C12.4961 1.19922 12.6602 1.11719 12.8516 1.11719C13.2617 1.08984 13.5625 1.36328 13.5625 1.71875Z"
      fill="white"
    />
  </svg>
);

export const BGSignIcon = ({ size = '66px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 66 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.75 9.125C32.625 7 29.125 6.875 26.875 9L6 28.25C4.75 29.375 2.875 29.25 1.75 28.125C0.625 26.875 0.625 25 1.875 23.875L22.75 4.5C27.375 0.25 34.5 0.375 39 4.875C43.5 9.375 43.5 16.75 39.125 21.25L12 49.125C10.875 50.375 10.75 52.25 11.75 53.625C13 55.125 15.375 55.25 16.875 53.875L48.75 21.125C52.125 17.625 57.75 17.625 61.125 21C64.5 24.375 64.625 29.625 61.375 33.125L50.125 45.5C47.25 48.5 47.375 53.25 50.375 56.25C52.375 58.25 55.5 59 58.25 58.125L61 57.25C62.5 56.625 64.25 57.5 64.75 59.125C65.25 60.625 64.5 62.375 62.875 62.875L60.25 63.75C55.25 65.5 49.75 64.125 46.125 60.5C40.875 55.25 40.75 46.875 45.75 41.375L57 29.125C58 28 58 26.375 56.875 25.25C55.875 24.25 54.125 24.25 53 25.25L21.125 58C17.125 62 10.625 61.75 7.125 57.375C4.125 53.625 4.375 48.375 7.75 45L34.75 17.125C37 14.875 37 11.375 34.75 9.125Z"
      fill="white"
      fillOpacity="0.5"
    />
  </svg>
);

export const PencilIcon = ({ size = '25px', color = 'white' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.03906 11.6406L13.7266 0.953125C14.6055 0.0742188 16.0469 0.0742188 16.9258 0.953125L18.2969 2.32422C18.4023 2.42969 18.5078 2.57031 18.5781 2.67578C19.1758 3.55469 19.0703 4.75 18.2969 5.52344L7.60938 16.2109C7.57422 16.2461 7.50391 16.2812 7.46875 16.3516C7.11719 16.6328 6.73047 16.8438 6.30859 16.9844L2.05469 18.2148C1.77344 18.3203 1.45703 18.25 1.24609 18.0039C1 17.793 0.929688 17.4766 1 17.1953L2.26562 12.9414C2.40625 12.4492 2.6875 11.9922 3.03906 11.6406ZM3.88281 13.4336L3.07422 16.1758L5.81641 15.3672C6.02734 15.2969 6.23828 15.1914 6.41406 15.0156L14.4648 6.96484L12.25 4.78516L4.23438 12.8359C4.19922 12.8359 4.19922 12.8711 4.16406 12.9062C4.02344 13.0469 3.95312 13.2227 3.88281 13.4336Z"
      fill={color}
    />
  </svg>
);

export const UploadIcon = ({ size = '25px', color = 'white' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9009 10.8032H11.4009V12.4907H15.9009C16.1822 12.4907 16.4634 12.772 16.4634 13.0532V15.8657C16.4634 16.1821 16.1822 16.4282 15.9009 16.4282H2.40092C2.08451 16.4282 1.83842 16.1821 1.83842 15.8657V13.0532C1.83842 12.772 2.08451 12.4907 2.40092 12.4907H6.90092V10.8032H2.40092C1.13529 10.8032 0.150918 11.8228 0.150918 13.0532V15.8657C0.150918 17.1313 1.13529 18.1157 2.40092 18.1157H15.9009C17.1314 18.1157 18.1509 17.1313 18.1509 15.8657V13.0532C18.1509 11.8228 17.1314 10.8032 15.9009 10.8032ZM4.93217 6.33838L8.30717 2.99854V12.4907C8.30717 12.9829 8.65873 13.3345 9.15092 13.3345C9.60795 13.3345 9.99467 12.9829 9.99467 12.4907V2.99854L13.3345 6.33838C13.4751 6.51416 13.6861 6.58447 13.9322 6.58447C14.1431 6.58447 14.354 6.51416 14.4947 6.33838C14.8462 6.02197 14.8462 5.49463 14.4947 5.17822L9.71342 0.396973C9.39701 0.0454102 8.86967 0.0454102 8.55326 0.396973L3.77201 5.17822C3.42045 5.49463 3.42045 6.02197 3.77201 6.33838C4.08842 6.68994 4.61576 6.68994 4.93217 6.33838ZM15.3384 14.4595C15.3384 14.0024 14.9517 13.6157 14.4947 13.6157C14.0025 13.6157 13.6509 14.0024 13.6509 14.4595C13.6509 14.9517 14.0025 15.3032 14.4947 15.3032C14.9517 15.3032 15.3384 14.9517 15.3384 14.4595Z"
      fill={color}
    />
  </svg>
);

export const OkIcon = ({ size = '25px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.707 0.293031C13.8945 0.480558 13.9998 0.734866 13.9998 1.00003C13.9998 1.26519 13.8945 1.5195 13.707 1.70703L5.70701 9.70703C5.51948 9.8945 5.26517 9.99982 5.00001 9.99982C4.73485 9.99982 4.48054 9.8945 4.29301 9.70703L0.29301 5.70703C0.110852 5.51843 0.010058 5.26583 0.0123364 5.00363C0.0146148 4.74143 0.119784 4.49062 0.305192 4.30521C0.4906 4.1198 0.741412 4.01464 1.00361 4.01236C1.26581 4.01008 1.51841 4.11087 1.70701 4.29303L5.00001 7.58603L12.293 0.293031C12.4805 0.10556 12.7348 0.000244141 13 0.000244141C13.2652 0.000244141 13.5195 0.10556 13.707 0.293031Z"
      fill="white"
    />
  </svg>
);

export const AngleLeft = ({ size = '25px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.25 13.8789C6.93359 13.8789 6.65234 13.7734 6.44141 13.5625L0.816406 7.9375C0.359375 7.51562 0.359375 6.77734 0.816406 6.35547L6.44141 0.730469C6.86328 0.273438 7.60156 0.273438 8.02344 0.730469C8.48047 1.15234 8.48047 1.89062 8.02344 2.3125L3.20703 7.12891L8.02344 11.9805C8.48047 12.4023 8.48047 13.1406 8.02344 13.5625C7.8125 13.7734 7.53125 13.8789 7.25 13.8789Z"
      fill="white"
    />
  </svg>
);

export const DeleteIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10 12v5M14 12v5M4 7h16M6 10v8a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-8M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2H9V5Z"
    />
  </svg>
);

export const EmptyBoxIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={size}
    height={size}
    viewBox="0 0 462.035 462.035"
    fill="currentColor"
  >
    <path d="M457.83 158.441c-.021-.028-.033-.058-.057-.087l-50.184-62.48a11.905 11.905 0 0 0-1.879-1.845c-2.16-2.562-5.355-4.225-8.967-4.225H65.292c-3.615 0-6.804 1.661-8.965 4.225a11.892 11.892 0 0 0-1.885 1.845l-50.178 62.48c-.023.029-.034.059-.057.087C1.655 160.602 0 163.787 0 167.39v193.07c0 6.5 5.27 11.771 11.77 11.771h438.496c6.5 0 11.77-5.271 11.77-11.771V167.39c.001-3.603-1.655-6.788-4.206-8.949zm-49.314-23.826 16.873 21.005h-16.873v-21.005zm-23.541-21.27v42.274H296.84c-2.514 0-4.955.805-6.979 2.293l-58.837 43.299-58.849-43.305a11.81 11.81 0 0 0-6.978-2.287H77.061v-42.274h307.914zM53.523 155.62H36.65l16.873-21.005v21.005zm384.975 193.07H23.54V179.16h137.796l62.711 46.148a11.78 11.78 0 0 0 13.954-.005l62.698-46.144h137.799V348.69z" />
  </svg>
);

export const CheckIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m6 12 4.243 4.243 8.484-8.486"
    />
  </svg>
);

export const EditIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <title />
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M20 16v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4" />
      <path d="M12.5 15.8 22 6.2 17.8 2l-9.5 9.5L8 16l4.5-.2z" />
    </g>
  </svg>
);

export const CloseIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="currentColor"
  >
    <path d="M16 0C7.164 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm0 30.032C8.28 30.032 2 23.72 2 16S8.28 2 16 2s14 6.28 14 14-6.28 14.032-14 14.032zm5.657-19.688a1 1 0 0 0-1.414 0l-4.242 4.242-4.242-4.242a1 1 0 1 0-1.415 1.414L14.586 16l-4.242 4.242a1 1 0 0 0 1.415 1.414l4.242-4.242 4.242 4.242a1 1 0 0 0 1.414-1.414L17.415 16l4.242-4.242a.999.999 0 0 0 0-1.414z" />
  </svg>
);

export const SaveIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="currentColor"
  >
    <path d="M26 0H6a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6zm-6 2v3a1 1 0 1 0 2 0V2h1v7H9V2zm10 24a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1v8a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V2h1a4 4 0 0 1 4 4zm-6-12H8a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1zm-1 12H9V16h14zm-11-6h8a1 1 0 0 0 0-2h-8a1 1 0 0 0 0 2zm0 4h8a1 1 0 0 0 0-2h-8a1 1 0 0 0 0 2z" />
  </svg>
);

export const SendEmailIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={size}
    height={size}
    viewBox="0 0 16.615 16.615"
  >
    <path
      d="M16.614 5.208a.502.502 0 0 0-.502-.501H7.53l1.208.813a.922.922 0 0 1 .199.19h6.455l-4.984 3.61-2.437-1.754-.965.65 3.111 2.218c.17.123.412.121.582 0l4.912-3.502v5.09H5.205V9.428l-.202.137a.929.929 0 0 1-.515.156.93.93 0 0 1-.286-.051v2.854c0 .277.225.502.502.502h11.409a.502.502 0 0 0 .502-.502V5.958a.396.396 0 0 0-.008-.072.368.368 0 0 0 .008-.08v-.598h-.001z"
      style={{
        fill: 'currentColor'
      }}
    />
    <path
      d="M4.308 8.799a.18.18 0 0 0 .281.148l3.735-2.514a.18.18 0 0 0 0-.299L4.59 3.621a.183.183 0 0 0-.185-.01.182.182 0 0 0-.096.16v1.454a13.268 13.268 0 0 1-1.479-.079C.888 4.916.368 3.75.347 3.7a.18.18 0 0 0-.166-.11c-.012 0-.024 0-.035.003A.181.181 0 0 0 0 3.77c0 2.944 3.495 3.571 4.307 3.677l.001 1.352z"
      style={{
        fill: 'currentColor'
      }}
    />
  </svg>
);

export const WhatsAppIcon = ({ size = '25px' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
    <path fill="currentColor" d="M12 2.04c-5.5 0-10 4.49-10 10.02 0 1.76.46 3.42 1.24 4.86L2 22l5.2-1.36a9.83 9.83 0 0 0 4.8 1.36c5.5 0 10-4.49 10-10.02S17.5 2.04 12 2.04zm5.85 14.86c-.2.56-.75.94-1.34.94h-.1c-.86-.1-5.38-1.97-7.81-4.4-2.42-2.44-4.3-6.95-4.4-7.81 0-.6.38-1.14.94-1.34.4-.14.8-.21 1.2-.21.34 0 .68.06 1 .17.42.15.8.44 1.07.81l1 1.37c.28.38.36.86.22 1.3-.14.45-.5.79-.95.92l-.52.15c.2.37.41.75.63 1.13.22.38.44.75.67 1.13l.26-.07c.45-.13.92-.03 1.3.22l2.4 1.63c.38.26.82.36 1.25.26l1.36-1c.38-.28.86-.36 1.3-.22.45.14.79.5.92.95l.15.52v.01z"/>
  </svg>
);

export const AddUserIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M7.991 8a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm0-7a3 3 0 1 1-3 3 3 3 0 0 1 3-3ZM9 15.5a.5.5 0 0 1-.5.5h-7A1.5 1.5 0 0 1 0 14.5 4.505 4.505 0 0 1 4.5 10h4a.5.5 0 0 1 0 1h-4A3.5 3.5 0 0 0 1 14.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 1 .5.5Zm7-3a.5.5 0 0 1-.5.5H13v2.5a.5.5 0 0 1-1 0V13H9.5a.5.5 0 0 1 0-1H12V9.5a.5.5 0 0 1 1 0V12h2.5a.5.5 0 0 1 .5.5Z"
      data-name="Path 179"
    />
  </svg>
);

export const SearchIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#a)">
      <circle
        cx={10.5}
        cy={10.5}
        r={6.5}
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path
        fill="currentColor"
        d="M19.646 20.354a.5.5 0 0 0 .708-.708l-.708.708Zm.708-.708-5-5-.708.708 5 5 .708-.708Z"
      />
    </g>
  </svg>
);

export const ArrowIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15 19-5.16-5a2.75 2.75 0 0 1 0-4L15 5"
    />
  </svg>
);

export const ProgressIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M11.7 2h-.8l.2 2h1.3c4 .3 7.3 3.5 7.5 7.6.2 4.4-3.2 8.2-7.6 8.4h-1.2l-.1 2H12.7c5.4-.4 9.5-5 9.3-10.4-.2-5.1-4.3-9.1-9.3-9.5h-.5c-.2-.1-.3-.1-.5-.1zm-3.5.7c-.5.3-1 .5-1.5.8l1.1 1.7c.3-.2.7-.4 1.1-.6l-.7-1.9zM4.5 5.4c-.4.4-.7.9-1 1.3l1.7 1c.2-.3.5-.6.8-1L4.5 5.4zm10.9 3-4.6 5.2-2.7-2.1L7 13.2l4.2 3.2L17 9.8l-1.6-1.4zM2.4 9c-.2.5-.3 1.1-.3 1.6l2 .3c.1-.4.1-.9.3-1.3l-2-.6zm1.7 4-2 .2v.3c.1.4.2.9.3 1.3l1.9-.6c-.1-.3-.2-.7-.2-1.1V13zm1.1 3.2-1.7 1.1c.3.5.6.9 1 1.3L6 17.3c-.3-.4-.6-.7-.8-1.1zm2.6 2.6-1.1 1.7c.5.3 1 .5 1.5.8l.8-1.8c-.5-.3-.9-.5-1.2-.7z"
    />
    <path
      d="M0 0h24v24H0z"
      style={{
        fill: 'none'
      }}
    />
  </svg>
);

export const LokedIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={size}
    height={size}
    viewBox="0 0 100 100"
  >
    <path
      fill="currentColor"
      d="M33 85h34c5.514 0 10-4.605 10-10.119v-22c0-5.514-4.486-10-10-10v-8.167C67 25.432 59.545 18 50.382 18h-.334C40.647 18 33 25.432 33 34.714v8.167c-5.514 0-10 4.486-10 10v22C23 80.395 27.486 85 33 85zm4-50.286C37 27.638 42.854 22 50.048 22h.334C57.457 22 63 27.518 63 34.714V43H37v-8.286zM73 75a6 6 0 0 1-6 6H33a6 6 0 0 1-6-6V53a6 6 0 0 1 6-6h34a6 6 0 0 1 6 6v22z"
    />
    <path
      fill="currentColor"
      d="M47 66.785v4.221C47 72.594 48.287 74 49.875 74h.25C51.713 74 53 72.594 53 71.006v-4.359a6.118 6.118 0 0 0 3.007-5.266A6.125 6.125 0 1 0 47 66.785z"
    />
  </svg>
);

export const RecycleIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={size}
    height={size}
    style={{
      enableBackground: 'new 0 0 109.48 122.88'
    }}
    viewBox="-6.7 0 122.88 122.88"
  >
    <path
      fill="currentColor"
      d="M2.35 9.63h38.3V3.76A3.754 3.754 0 0 1 44.4 0h21.14c2.07 0 3.76 1.69 3.76 3.76v5.87h37.83a2.36 2.36 0 0 1 2.35 2.35V23.5H0V11.98c0-1.29 1.05-2.35 2.35-2.35zm6.34 19.98h92.92c1.94 0 3.7 1.6 3.52 3.52l-7.86 86.23c-.18 1.93-1.59 3.52-3.52 3.52h-77.3c-1.93 0-3.35-1.59-3.52-3.52L5.17 33.13c-.18-1.93 1.58-3.52 3.52-3.52zm25.24 65.5-6.16-10.59c-1.11-1.92-1.53-3.42-.6-5.64l3.62-6.09-3.63-1.95 12.17-.05L45.4 81.4l-3.75-2.15-6.08 10.78c-.58 1.02-1.06 1.8-1.35 2.96-.17.71-.26 1.42-.29 2.12zm2.45-32.75 5.86-10.2c1.65-2.05 3.7-2.79 5.65-2.24 1.68.48 2.15 1.23 3.04 2.6 1.07 1.63 2 3.37 2.98 5.08l-6.55 11.26-10.98-6.5zm13.33-13.93 12.26-.04c2.22-.01 3.73.39 5.18 2.3l3.46 6.18 3.51-2.17-6.04 10.56-12.23-.05 3.74-2.17-6.3-10.66c-.6-1.01-1.03-1.81-1.89-2.65-.52-.5-1.09-.92-1.69-1.3zM76.4 67.42l5.9 10.17c.95 2.45.57 4.6-.89 6.01-1.25 1.22-2.14 1.24-3.77 1.34-1.95.11-3.92.05-5.89.04l-6.47-11.3 11.12-6.26zm5.4 18.51-6.09 10.64c-1.1 1.92-2.2 3.03-4.58 3.34l-7.08-.09.12 4.12-6.13-10.52 6.15-10.56.01 4.32 12.38-.12c1.17-.01 2.09.01 3.24-.31.7-.21 1.35-.49 1.98-.82zM52.67 99.7l-11.76.02c-2.6-.4-4.27-1.81-4.77-3.77-.43-1.69-.01-2.48.73-3.94.88-1.74 1.92-3.42 2.91-5.12l13.02.05-.13 12.76z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd'
      }}
    />
  </svg>
);

export const RestoreIcon = ({ size = '25px', color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
  >
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5a3.5 3.5 0 0 0-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z" />
  </svg>
);

export const BackIcon = ({ size = '25px', color = '#ffffff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    className="icon"
    viewBox="0 0 1024 1024"
  >
    <path
      fill={color}
      d="M669.6 849.6c8.8 8 22.4 7.2 30.4-1.6s7.2-22.4-1.6-30.4l-309.6-280c-8-7.2-8-17.6 0-24.8l309.6-270.4c8.8-8 9.6-21.6 2.4-30.4-8-8.8-21.6-9.6-30.4-2.4L360.8 480.8c-27.2 24-28 64-.8 88.8l309.6 280z"
    />
  </svg>
);

export const QuestIcon = ({ size = '25px', color = '#ffffff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M10.125 8.875a1.875 1.875 0 1 1 2.828 1.615c-.475.281-.953.708-.953 1.26V13"
    />
    <circle cx={12} cy={16} r={1} fill={color} />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M7 3.338A9.954 9.954 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-1.821.487-3.53 1.338-5"
    />
  </svg>
);

export const NextIcon = ({ size = '20px', color = '#ffffff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.5}
    className="icon icon-tabler icon-tabler-chevron-right"
    viewBox="0 0 24 24"
  >
    <path stroke="none" d="M0 0h24v24H0z" />
    <path d="m9 6 6 6-6 6" />
  </svg>
);

export const PrevIcon = ({ size = '20px', color = '#ffffff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.5}
    className="icon icon-tabler icon-tabler-chevron-left"
    viewBox="0 0 24 24"
  >
    <path stroke="none" d="M0 0h24v24H0z" />
    <path d="m15 6-6 6 6 6" />
  </svg>
);

export const MenuIcon = ({ size = '20px', color = '#ffffff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.5}
    className="icon icon-tabler icon-tabler-menu-2"
    viewBox="0 0 24 24"
  >
    <path stroke="none" d="M0 0h24v24H0z" />
    <path d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

export const SuccessPaymentIcon = ({ size = '100px', color = '#25ae88' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 50 50"
    width={size}
    height={size}
  >
    <circle
      cx={24}
      cy={24}
      r={24}
      style={{
        fill: color
      }}
    />
    <path
      d="M38 15 22 33l-10-8"
      style={{
        fill: 'none',
        stroke: '#fff',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: 10
      }}
    />
  </svg>
);

export const ErrorPaymentIcon = ({ size = '100px', color = '#d75a4a' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 50 50"
    width={size}
    height={size}
  >
    <circle
      cx={24}
      cy={24}
      r={24}
      style={{
        fill: color
      }}
    />
    <path
      d="m16 34 9-9 9-9M16 16l9 9 9 9"
      style={{
        fill: 'none',
        stroke: '#fff',
        strokeWidth: 2,
        strokeLinecap: 'round',
        strokeMiterlimit: 10
      }}
    />
  </svg>
);

export const PaypalIcon = ({ size = '60px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 -140 780 780"
    width={size}
    height={size}
  >
    <path
      fill="#FFF"
      d="M725 0H55C24.673 0 0 24.673 0 55v391c0 30.327 24.673 55 55 55h670c30.325 0 55-24.673 55-55V55c0-30.327-24.675-55-55-55z"
    />
    <path
      fill="#003087"
      d="M168.38 169.85c-8.399-5.774-19.359-8.668-32.88-8.668H83.154c-4.145 0-6.435 2.073-6.87 6.214l-21.265 133.48c-.221 1.311.107 2.51.981 3.6.869 1.093 1.962 1.636 3.271 1.636h24.864c4.361 0 6.758-2.068 7.198-6.216l5.888-35.985c.215-1.744.982-3.162 2.291-4.254 1.308-1.09 2.944-1.804 4.907-2.13 1.963-.324 3.814-.487 5.562-.487 1.743 0 3.814.11 6.217.327 2.397.218 3.925.324 4.58.324 18.756 0 33.478-5.285 44.167-15.866 10.684-10.577 16.032-25.244 16.032-44.004 0-12.868-4.202-22.192-12.597-27.975zm-26.99 40.08c-1.094 7.635-3.926 12.649-8.506 15.049-4.581 2.403-11.124 3.597-19.629 3.597l-10.797.328 5.563-35.007c.434-2.397 1.851-3.597 4.252-3.597h6.218c8.72 0 15.049 1.257 18.975 3.761 3.924 2.51 5.233 7.802 3.924 15.869z"
    />
    <path
      fill="#009CDE"
      d="M720.79 161.18h-24.208c-2.405 0-3.821 1.2-4.253 3.599l-21.267 136.1-.328.654c0 1.096.437 2.127 1.311 3.109.868.979 1.963 1.471 3.271 1.471h21.595c4.138 0 6.429-2.068 6.871-6.215l21.265-133.81v-.325c-.002-3.053-1.424-4.58-4.257-4.58z"
    />
    <path
      fill="#003087"
      d="M428.31 213.86c0-1.088-.438-2.126-1.306-3.106-.875-.981-1.857-1.474-2.945-1.474h-25.191c-2.404 0-4.366 1.096-5.89 3.271l-34.679 51.04-14.394-49.075c-1.096-3.488-3.493-5.236-7.198-5.236h-24.54c-1.093 0-2.075.492-2.942 1.474-.875.98-1.309 2.019-1.309 3.106 0 .44 2.127 6.871 6.379 19.303 4.252 12.434 8.833 25.848 13.741 40.244 4.908 14.394 7.468 22.031 7.688 22.898-17.886 24.43-26.826 37.518-26.826 39.26 0 2.838 1.417 4.254 4.253 4.254h25.191c2.399 0 4.361-1.088 5.89-3.271l83.427-120.4c.433-.433.651-1.193.651-2.289z"
    />
    <path
      fill="#009CDE"
      d="M662.89 209.28h-24.865c-3.056 0-4.904 3.599-5.559 10.797-5.677-8.72-16.031-13.088-31.083-13.088-15.704 0-29.065 5.89-40.077 17.668-11.016 11.779-16.521 25.631-16.521 41.551 0 12.871 3.761 23.121 11.285 30.752 7.524 7.639 17.611 11.451 30.266 11.451 6.323 0 12.757-1.311 19.3-3.926 6.544-2.617 11.665-6.105 15.379-10.469 0 .219-.222 1.198-.654 2.942-.44 1.748-.655 3.06-.655 3.926 0 3.494 1.414 5.234 4.254 5.234h22.576c4.138 0 6.541-2.068 7.193-6.216l13.415-85.389c.215-1.309-.111-2.507-.981-3.599-.876-1.087-1.964-1.634-3.273-1.634zm-42.694 64.452c-5.562 5.453-12.269 8.179-20.12 8.179-6.328 0-11.449-1.742-15.377-5.234-3.928-3.483-5.891-8.282-5.891-14.396 0-8.064 2.727-14.884 8.181-20.446 5.446-5.562 12.214-8.343 20.284-8.343 6.102 0 11.174 1.8 15.212 5.397 4.032 3.599 6.055 8.563 6.055 14.888-.001 7.851-2.783 14.505-8.344 19.955z"
    />
    <path
      fill="#003087"
      d="M291.23 209.28h-24.864c-3.058 0-4.908 3.599-5.563 10.797-5.889-8.72-16.25-13.088-31.081-13.088-15.704 0-29.065 5.89-40.078 17.668-11.016 11.779-16.521 25.631-16.521 41.551 0 12.871 3.763 23.121 11.288 30.752 7.525 7.639 17.61 11.451 30.262 11.451 6.104 0 12.433-1.311 18.975-3.926 6.543-2.617 11.778-6.105 15.704-10.469-.875 2.616-1.309 4.907-1.309 6.868 0 3.494 1.417 5.234 4.253 5.234h22.574c4.141 0 6.543-2.068 7.198-6.216l13.413-85.389c.215-1.309-.112-2.507-.981-3.599-.873-1.087-1.962-1.634-3.27-1.634zm-42.695 64.614c-5.563 5.351-12.382 8.017-20.447 8.017-6.329 0-11.4-1.742-15.214-5.234-3.819-3.483-5.726-8.282-5.726-14.396 0-8.064 2.725-14.884 8.18-20.446 5.449-5.562 12.211-8.343 20.284-8.343 6.104 0 11.175 1.8 15.214 5.398 4.032 3.599 6.052 8.563 6.052 14.888 0 8.069-2.781 14.778-8.343 20.116z"
    />
    <path
      fill="#009CDE"
      d="M540.04 169.85c-8.398-5.774-19.356-8.668-32.879-8.668h-52.02c-4.364 0-6.765 2.073-7.197 6.214l-21.266 133.48c-.221 1.312.106 2.511.981 3.601.865 1.092 1.962 1.635 3.271 1.635h26.826c2.617 0 4.361-1.416 5.235-4.252l5.89-37.949c.216-1.744.98-3.162 2.29-4.254 1.309-1.09 2.943-1.803 4.908-2.13 1.962-.324 3.812-.487 5.562-.487 1.743 0 3.814.11 6.214.327 2.399.218 3.931.324 4.58.324 18.76 0 33.479-5.285 44.168-15.866 10.688-10.577 16.031-25.244 16.031-44.004.002-12.867-4.199-22.191-12.594-27.974zm-33.534 53.82c-4.799 3.271-11.997 4.906-21.592 4.906l-10.47.328 5.562-35.007c.432-2.397 1.849-3.597 4.252-3.597h5.887c4.798 0 8.614.218 11.454.653 2.831.44 5.562 1.799 8.179 4.089 2.618 2.291 3.926 5.618 3.926 9.98 0 9.16-2.402 15.375-7.198 18.648z"
    />
  </svg>
);

export const SeePassword = ({ size = '25x', color = '#333333' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="#fff"
    viewBox="0 0 24 24"
    width={size}
    height={size}
  >
    <g stroke={color} strokeWidth={1.5}>
      <path
        strokeLinecap="round"
        d="M9 4.46A9.84 9.84 0 0 1 12 4c4.182 0 7.028 2.5 8.725 4.704C21.575 9.81 22 10.361 22 12c0 1.64-.425 2.191-1.275 3.296C19.028 17.5 16.182 20 12 20c-4.182 0-7.028-2.5-8.725-4.704C2.425 14.192 2 13.639 2 12c0-1.64.425-2.191 1.275-3.296A14.465 14.465 0 0 1 5 6.821"
      />
      <path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
    </g>
  </svg>
);

export const BlockPassword = ({ size = '25x', color = '#333333' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
  >
    <g
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M14.83 9.18A4 4 0 0 0 8 12.01a4 4 0 0 0 1.16 2.82M12 16.01a4 4 0 0 0 4-4" />
      <path d="M17.61 6.39 6.38 17.62A21.8 21.8 0 0 1 2 11.99c4.71-8.23 10.44-10.1 15.61-5.6ZM21 3l-3.39 3.39M6.38 17.62 3 21M19.57 8.43A25.336 25.336 0 0 1 22 12.01c-4 7-8.73 9.39-13.23 7.22" />
    </g>
  </svg>
);

export const RoketIcon = ({ size = '30px', color = '#333333' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="_x32_"
    fill="#000"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <g id="SVGRepo_iconCarrier">
      <style>{'.st0{fill:#fff}'}</style>
      <path
        d="m154.219 205.188 12 129.843-55.297 70.532-14.516-109zM357.781 205.188l-12.015 129.843 55.297 70.532 14.531-109zM323.813 62.219C305.125 23.328 275.656 0 256 0s-49.125 23.344-67.813 62.219h135.626zM331.328 80.469H180.672c-6.641 19.156-10.594 41.094-10.047 65.188 1.609 69.063 18.047 190.984 18.047 190.984l122.641-.016 12 .016s16.453-121.938 18.031-190.984c.578-24.094-3.375-46.048-10.016-65.188zM256 231.031c-23.578 0-42.688-19.094-42.688-42.672s19.125-42.672 42.688-42.672 42.672 19.094 42.656 42.672c.016 23.579-19.093 42.672-42.656 42.672zM429.516 512c-6.109-17.594-22.859-30.219-42.531-30.219a44.962 44.962 0 0 0-17.766 3.625c-1.875-20.578-19.188-36.688-40.25-36.688-3.047 0-6 .328-8.844.969.031-.563.031-1.125.031-1.688 0-15.531-12.594-28.125-28.125-28.125-4.031 0-7.875.844-11.344 2.375-9.734-17.219-12.563-62.156-12.563-62.156h-25.5s-3.266 49.344-14.813 65.688a23.206 23.206 0 0 0-8.75-1.688c-13.016 0-23.563 10.547-23.563 23.563 0 .984.063 1.953.188 2.906-3.719-1.203-3.281-1.844-7.406-1.844-16.484 0-30.531 10.406-35.938 25a50.955 50.955 0 0 0-19.625-3.906c-25.156 0-46.063 18.219-50.234 42.188h347.033z"
        className="st0"
      />
    </g>
  </svg>
);

export const PadLookIcon = ({ size = '30px', color = '#ffffff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="jam jam-padlock-open-f"
    preserveAspectRatio="xMinYMin"
    viewBox="-5 -2 24 24"
    width={size}
    height={size}
    fill={color}
  >
    <path d="M12 5h-2a3 3 0 1 0-6 0v5h8a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2V5a5 5 0 1 1 10 0zM7 17a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
  </svg>
);

export const CancelIcon = ({ size = '25px' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
  >
    <path
      fill="white"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-3.5-9.293a1 1 0 0 0 0 1.414L10.586 12l-2.086 2.086a1 1 0 1 0 1.414 1.414L12 13.414l2.086 2.086a1 1 0 1 0 1.414-1.414L13.414 12l2.086-2.086a1 1 0 1 0-1.414-1.414L12 10.586l-2.086-2.086a1 1 0 0 0-1.414 0z"
    />
  </svg>
);

export const NOMIcon = ({ size = '25px' }) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  fill="#96F50F"
  stroke="currentColor"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
  width={size}
  height={size}
>
  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
  <path d="M3 9h18"></path>
  <path d="M9 9v12"></path>
</svg>
);

export const FileUploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 39 38"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="38"
    height="39"
  >
    <path
      d="M21.5 5H5.5C4.43913 5 3.42172 5.42143 2.67157 6.17157C1.92143 6.92172 1.5 7.93913 1.5 9V29M1.5 29V33C1.5 34.0609 1.92143 35.0783 2.67157 35.8284C3.42172 36.5786 4.43913 37 5.5 37H29.5C30.5609 37 31.5783 36.5786 32.3284 35.8284C33.0786 35.0783 33.5 34.0609 33.5 33V25M1.5 29L10.672 19.828C11.4221 19.0781 12.4393 18.6569 13.5 18.6569C14.5607 18.6569 15.5779 19.0781 16.328 19.828L21.5 25M33.5 17V25M33.5 25L30.328 21.828C29.5779 21.0781 28.5607 20.6569 27.5 20.6569C26.4393 20.6569 25.4221 21.0781 24.672 21.828L21.5 25M21.5 25L25.5 29M29.5 5H37.5M33.5 1V9M21.5 13H21.52"
      stroke="#3A67A6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BorrarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 21"
    fill= "none"
    stroke="#F24822"
    strokeWidth="1" // Modificado para hacer el icono más grueso
    strokeLinecap="round"
    strokeLinejoin="round"
    width="18"
    height="21"
  >
    <path
      d="M7.16406 2.375C7.04688 2.375 6.96875 2.45312 6.89062 2.53125L6.14844 3.625H11.8125L11.0703 2.53125C11.0312 2.45312 10.9141 2.375 10.7969 2.375H7.16406ZM14.0781 3.625H14.5859H16.5H16.8125C17.3203 3.625 17.75 4.05469 17.75 4.5625C17.75 5.10938 17.3203 5.5 16.8125 5.5H16.3438L15.4062 18.1953C15.2891 19.5234 14.2344 20.5 12.9062 20.5H5.05469C3.72656 20.5 2.67188 19.5234 2.55469 18.1953L1.61719 5.5H1.1875C0.640625 5.5 0.25 5.10938 0.25 4.5625C0.25 4.05469 0.640625 3.625 1.1875 3.625H1.5H3.375H3.88281L5.32812 1.47656C5.71875 0.890625 6.42188 0.5 7.16406 0.5H10.7969C11.5391 0.5 12.2422 0.890625 12.6328 1.47656L14.0781 3.625ZM14.4688 5.5H3.49219L4.42969 18.0781C4.46875 18.3906 4.74219 18.625 5.05469 18.625H12.9062C13.2188 18.625 13.4922 18.3906 13.5312 18.0781L14.4688 5.5Z"
      fill="#F24822"
    />
  </svg>
);

export const FileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 38 51"
    fill= "none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="27"
    height="42"
  >
    <path d="M31.5 45.5625C32.2812 45.5625 33.0625 44.8789 33.0625 44V15.875H25.25C23.4922 15.875 22.125 14.5078 22.125 12.75V4.9375H6.5C5.62109 4.9375 4.9375 5.71875 4.9375 6.5V44C4.9375 44.8789 5.62109 45.5625 6.5 45.5625H31.5ZM0.25 6.5C0.25 3.08203 2.98438 0.25 6.5 0.25H22.6133C24.2734 0.25 25.8359 0.933594 27.0078 2.10547L35.8945 10.9922C37.0664 12.1641 37.75 13.7266 37.75 15.3867V44C37.75 47.5156 34.918 50.25 31.5 50.25H6.5C2.98438 50.25 0.25 47.5156 0.25 44V6.5Z" fill="#3A67A6"/>
  </svg>
);